export default {
  API_URL: "https://api.delivitapp.com/",

  // AGENCY AUTH

  GET_EMAIL_OTP: "api/v1/provider/emailOtp",
  SING_UP: "api/v1/provider/register",
  LOGIN: "api/v1/provider/login",
  FORGET_PASSWORD: "api/v1/provider/forgotPassword",
  VERIFY_OTP: "api/v1/provider/verifyOtp",
  RESET_PASSWORD: "api/v1/provider/resetPassword",

  // dashboard

  DASHBOARD_REPORT: "api/v1/provider/dashboardReport",

  // profile

  CHANGE_PASSWORD: "api/v1/provider/changePassword",
  GET_PROFILE_INFO: "api/v1/provider/profile",
  UPDATE_PROFILE: "api/v1/provider/updateProfile",

  // manage services

  GET_SERVICES: "api/v1/provider/getservices",
  SELECT_SERVICE: "api/v1/provider/selectservices",

  // manage drivers

  GET_DRIVERS: "api/v1/provider/getdriverwithfilter",
  DELETE_DRIVER: "api/v1/provider/deleteDriver",
  ADD_DRIVER: "api/v1/provider/addDriver",
  EDIT_DRIVER: "api/v1/provider/updateDriver",
  GET_DRIVER_BY_ID: "api/v1/provider/getById/",
  GET_DRIVER_VIEW: "api/v1//provider/viewdriver/",
  EXPORT_DRIVER_CSV: "api/v1/provider/exportsDrivers",
  IMPORT_DRIVERS_CSV: "api/v1/provider/importDriverViaCSV",
  BLOCK_DRIVER: "api/v1/provider/blockUnblock",

  // booking request

  GET_BOOKING_REQUESTS: "api/v1/provider/allBookingsWithFilter",
  GET_MY_BOOKINGS_REQUESTS: "api/v1/provider/mybookingWithFilter",
  VIEW_BOOKING: "api/v1/provider/bookingDetail/",
  ACCEPT_BOOKING: "api/v1/booking/acceptByAgency",
  REJECT_BOOKING: "api/v1/booking/reject",
  MAKE_OFFER: "api/v1/booking/acceptByAgency",

  // transaction history

  GET_TRANSACTION_HISTORY: "api/v1/provider/transaction",
  // GET_TRANSACTION_HISTORY:
  // "api/v1/provider/transaction",

  // setting
  // ==> payment method

  ADD_PAYMENT_METHOD: "api/v1/provider/addBankAccount",
  GET_PAYMENT_METHODS: "api/v1/provider/getBankAccount",
  DELETE_PAYMENT_METHODS: "api/v1/provider/deleteAccount",

  // earning

  GET_EARNING: "api/v1/provider/earning",

  // payouts

  GET_DRIVERS_PAYOUT_LIST: "api/v1/provider/driverPayout/getdriverwithfilter",
  DRIVER_PAYOUT: "api/v1/provider/driverPayout/addmoney",

  //   wallet
  GET_WALLET_INFO: "api/v1/payment/provider/wallet/list",
  // content
  // help & support

  HELP_AND_SUPPORT: "/api/v1/admin/sendsupportemail",
  TERMS_AND_CONDITION: "/api/v1/admin/termsandconditions",
  PRIVACY_POLICY: "/api/v1/admin/privacyPolicy",
  ABOUT_US: "/api/v1/admin/aboutus",
  GET_FAQS: "/api/v1/provider/getAllFaqs",

  // file upload
  FILE_UPLOAD: "/api/v1/adminSetting/uploadFile",

  // get assign driver
  GET_ASSIGN_DRIVER: "/api/v1/provider/getassigndriverwithfilter",
  BOOKING_ASSIGN_DRIVER: "/api/v1/booking/assign/driver",
  CONNECT_WITH_STRIPE: "/api/v1/provider/stripe/connect/details",

  // guest booking
  BOOKING_LISTS: "/api/v1/provider/allGuestBookingsWithFilter",
  BOOKING_DETAILS: "/api/v1/provider/guestBookingDetail/",
  BOOKING_ACCEPT: "/api/v1/booking/guest/acceptByAgency",
  BOOKING_REJECT: "/api/v1/booking/guest/reject",
  MYGUEST_BOOKING: "/api/v1/provider/myGuestBookingWithFilter",
  BOOKING_GUEST_ASSIGN_DRIVER: "/api/v1/booking/guest/assign/driver",

};
